import { useDispatch } from "react-redux";
import { APP_BASE_URL, LOGOUT_URL } from "../../Common/EndPoints";
import useFirebaseCloudMessaging from "../../hooks/fcm/useFirebaseCloudMessaging";
import { logoutSuccess } from "../../features/authentication/auth-slice";
import axios from "axios";
import toast from "react-hot-toast";
import { useState } from "react";
import { getLocalStorage } from "../../Utils/storage-utils";
import { resetSidebar } from "../NewSidebar/sidebarSlice";

const useLogout = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const { unregisterUser } = useFirebaseCloudMessaging();

  const handleLogout = async (user_id = null, loAllDevices = false) => {
    const url = `${APP_BASE_URL}${LOGOUT_URL}`;
    const params = {
      fromAllDevice: loAllDevices,
      userid: user_id ?? getLocalStorage("userId"),
    };
    if (!params?.userid) {
      return;
    }
    setLoading(true);
    try {
      const logoutRes = await axios.post(url, {}, { params });
      const unregister = await unregisterUser();
      dispatch(resetSidebar());
      dispatch(logoutSuccess());
      toast.success("User logged out successfully");
      console.log("logout success", logoutRes);
    } catch (err) {
      console.log("logout failed", err);
      toast.error(err.message ?? "Falied to logout");
    } finally {
      setLoading(false);
    }
  };

  return {
    loading: loading,
    handleLogout: handleLogout,
  };
};

export default useLogout;
